// removed by extract-text-webpack-plugin
module.exports = {"editHeader":"_1p7LF _3ekOX _1-OXK _3Xg8b","editHeaderButtons":"_1fLfb _2irZW","editHeaderButton":"_5L-9P","saveButton":"_1Fhnq _5L-9P","cancelButton":"_2IMc- _5L-9P"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/EditHeader.css
// module id = 2227
// module chunks = 3